import { FaPowerOff as LogoutIcon } from 'react-icons/fa';

export default LogoutIcon;
